import React, { useState, useEffect } from 'react';

const Textbox = ({ label, options = [], value, onChange, placeholder, disabled }) => {
  const [query, setQuery] = useState(value);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [showOptions, setShowOptions] = useState(false);
  const [selectedOption, setSelectedOption] = useState(value || '');

  useEffect(() => {
    setQuery(value || '');
    setSelectedOption(value || '');
  }, [value]);

  const handleChange = (e) => {
    const val = e.target.value;
    setQuery(val);
    onChange?.(val);

    if (!val.trim()) {
      setShowOptions(false);
      setFilteredOptions([]);
    } else {
      const matches = options.filter((opt) =>
        opt.toLowerCase().includes(val.toLowerCase())
      );
      setFilteredOptions(matches);
      setShowOptions(true);
    }
  };

  const handleSelect = (option) => {
    setQuery(option);
    setSelectedOption(option);
    setShowOptions(false);
    onChange?.(option);
  };

  return (
    <div className="relative w-full text-sm font-medium">
      {label && <p className="text-[#514D4C] mb-1">{label}</p>}

      <input
        type="text"
        value={query}
        disabled={disabled}
        onChange={handleChange}
        onFocus={() => {
          setFilteredOptions(options);
          setShowOptions(true);
        }}
        onBlur={() => setTimeout(() => setShowOptions(false), 150)}
        placeholder={placeholder || 'Type to search...'}
        className="w-full border border-gray-300 rounded-md text-[#514D4C] p-2 focus:outline-none focus:ring-1 focus:ring-primary text-sm"
      />
      {showOptions && filteredOptions.length > 0 && (
        <ul className="absolute z-50 w-full bg-white shadow-lg border rounded-md mt-1  p-2 max-h-40 overflow-y-auto textbox-dropdown">
          {filteredOptions.map((option, index) => (
            <li
              key={index}
              onMouseDown={() => handleSelect(option)}
              className={`px-3 py-2 cursor-pointer text-[#514D4C] font-medium text-sm 
                ${
                  selectedOption === option
                    ? 'bg-primary/85 text-white'
                    : 'hover:bg-gray-100'
                }`}
            >
              {option}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Textbox;
